var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCritContent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 107,
    viewBox: "0 0 107 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11704_5511)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 0.75H91C99.4223 0.75 106.25 7.57766 106.25 16V91C106.25 99.4223 99.4223 106.25 91 106.25H16C7.57766 106.25 0.75 99.4223 0.75 91V16C0.750001 7.57766 7.57766 0.75 16 0.75Z",
    fill: "#F0EAF7",
    stroke: "#7033B7",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9824 23C36.4252 23 23 33.96 23 47.4769V83H32.9765V47.3763C32.9765 38.3555 41.9326 31.0297 53 31.0297C64.0499 31.0297 73.0235 38.3412 73.0235 47.3763V82.9856H83V47.4769C82.9648 33.96 69.5396 23 52.9824 23Z",
    fill: "#7033B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0235 82.9856H38.9413V47.1178C38.9413 40.7831 45.2229 35.655 52.9824 35.655C60.7419 35.655 67.0235 40.7831 67.0235 47.1178V82.9856Z",
    fill: "#7033B7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11704_5511"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 107,
    height: 107,
    rx: 15.1059,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCritContent);
export default __webpack_public_path__ + "static/media/CritContent.34429c9d0a89a0f9fd5812451533f1f8.svg";
export { ForwardRef as ReactComponent };